import SearchCoreModal, { SearchCoreProps } from './SearchCoreModal';
import { Icon } from 'react-frontier';
import { InventoryType } from '../SiteClasses';
import API from '../API';

var SearchTypeModal = (props: SearchCoreProps<InventoryType> & { exclude?: number[] })=>{
	return <SearchCoreModal
		title='Seleccionar tipo'
		searchPlaceholder='Buscar tipo'
		{...props}
		searchData={(query, page, pageSize)=>{
			return API.getInventoryTypes(query, page * pageSize, pageSize).then(res=>{
				if(res.error) return { ...res, data: [] };
				var excludeSet = new Set(props.exclude || []);
				return { ...res, data: (res.data || []).filter(t=>!excludeSet.has(t.type_id)) };
			});
		}}
		pageSize={8}
		table={[
			{ name: 'ID', key: 'type_id', collapsing: true },
			{ name: 'Tipo', key: 'type_name', render: (val: any, item: InventoryType)=><><Icon name={item.type_icon || 'question-circle'} /> {val || '--'}</> },
		]}
	/>
}

export default SearchTypeModal;
